var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AvVideoOffColor as AvVideoOffIcon } from '@class-ui/icons/dist/AvVideoOffColor';
import { AvVideoOn as AvVideoOnIcon } from '@class-ui/icons/dist/AvVideoOn';
import { ActionBarItem } from '../ActionBarItem';
export const CameraButton = (props) => {
    const { isEnabled } = props, rest = __rest(props, ["isEnabled"]);
    const icon = isEnabled ? _jsx(AvVideoOnIcon, {}) : _jsx(AvVideoOffIcon, {});
    return _jsx(ActionBarItem, Object.assign({ icon: icon }, rest));
};
